<template>
  <vl-properties-list v-vl-spacer:bottom.small>
    <vl-properties-label>{{ $t('operationspecification.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationspecification.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationspecification.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('operationspecification.detail.schema') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.schema }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { OperationSpecificationDetailDto } from '@/api/backoffice/clients';

const props = defineProps<{
  detail: OperationSpecificationDetailDto;
}>();
</script>
